import createPermission, {any} from 'permissions/createPermission'

import * as navigation from './navigation'

export const content = createPermission(any(
    ...Object.values(navigation)
))

export default createPermission('unit.info')